import { Grid } from "@mui/material";
import AnalysisCardItem from "./AnalysisCardItem";

const AnalysisCards = ({ historicDatasets, plottingType, chartTimeRange, handleRemoveAnalysisCard, chartRef }) => {

    const safeValueExtraction = (dataset, position, property) => {
        return dataset.length ? dataset.at(position)[property] : 0
    }

    return (
        <Grid container spacing={2}>
            {

                historicDatasets.map(dataset => {
                    return (
                        <Grid key={dataset.id} size={{xs: 12, md: 6, xl: 3}}>
                            {
                                plottingType !== "" && historicDatasets &&
                                <AnalysisCardItem
                                    insturmentIsin={dataset.id}
                                    label={dataset.name}
                                    currentValue={safeValueExtraction(dataset.points, -1, plottingType)}
                                    referenceValue={safeValueExtraction(dataset.points, 0, plottingType)}
                                    referenceTimeRange={chartTimeRange}
                                    handleRemoveAnalysisCard={handleRemoveAnalysisCard}
                                    chartRef={chartRef}
                                />
                            }
                        </Grid>
                    )
                })

            }
        </Grid >

    );
};

export default AnalysisCards;